import * as React from "react";
import { Block } from "baseui/block";

type TWidthContainerProps = {
  maxWidth?: string;
  size?: string;
  center?: boolean;
  children: React.ReactNode;
};

export const SIZE = {
  mini: "mini",
  default: "default",
  compact: "compact",
  large: "large",
};

export function WidthContainer({
  children,
  size = SIZE.default,
  center = true,
  maxWidth = "600px",
  ...props
}: TWidthContainerProps) {
  return (
    <Block>
      <Block
        margin="0 auto"
        minWidth={["100%", "100%", size === SIZE.mini ? "150px" : "320px"]}
        maxWidth={[null, null, maxWidth]}
      >
        <Block
          display="flex"
          flexDirection="column"
          alignItems={center ? "center" : null}
          {...props}
        >
          {children}
        </Block>
      </Block>
    </Block>
  );
}
